import styled from 'styled-components';
import { Colors } from 'theme/colors';

export const Wrapper = styled.footer`
  width: 100%;
  height: auto;
  background-color: ${Colors.background.blue};
`;
